export default {
	id: 'SIMPLE_PREMIUM_COMM_1M_49_99_6M_16',
	providers: {
		paltaMap: {
			USD: 'simple_premium_comm_1m_49_99_6m_16_usd',
			EUR: 'simple_premium_comm_1m_49_99_6m_16_eur',
			GBP: 'simple_premium_comm_1m_49_99_6m_16_gbp',
			AUD: 'simple_premium_comm_1m_83_3_6m_24_aud',
			CAD: 'simple_premium_comm_1m_83_3_6m_24_cad',
			DKK: 'simple_premium_comm_1m_430_6m_134_dkk',
			NOK: 'simple_premium_comm_1m_665_6m_209_nok',
			SEK: 'simple_premium_comm_1m_665_6m_209_sek',
			MXN: 'simple_premium_comm_1m_829_6m_265_mxn',
			TRY: 'simple_premium_comm_1m_1665_6m_529_try',
			ARS: 'simple_premium_comm_1m_66660_6m_21340_ars',
			COP: 'simple_premium_comm_1m_200010_6m_64020_cop',
			CLP: 'simple_premium_comm_1m_49990_6m_16000_clp',
		},
		primer: 'prd_wJAhZXrNrxT5',
	},
	model: {
		commitment_period: 6,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 16,
			EUR: 16,
			GBP: 16,
			AUD: 24,
			CAD: 24,
			DKK: 134,
			NOK: 209,
			SEK: 209,
			MXN: 265,
			TRY: 529,
			ARS: 21340,
			COP: 64020,
			CLP: 16000,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 49.99,
			EUR: 49.99,
			GBP: 49.99,
			AUD: 83.3,
			CAD: 83.3,
			DKK: 430,
			NOK: 665,
			SEK: 665,
			MXN: 829,
			TRY: 1665,
			ARS: 66660,
			COP: 200010,
			CLP: 49990,
		},
	},
}
